import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumCtVirtualNo implements BaseEnumType {
  private static allValues: EnumCtVirtualNo[] = []; // make sure this is top-most
  
  public static realAndVirtual = new EnumCtVirtualNo(0, "RealAndVirtual", "enum_ct_virtual_no_real_and_virtual");
  public static virtual = new EnumCtVirtualNo(1, "Virtual", "enum_ct_virtual_no_virtual");
  public static real = new EnumCtVirtualNo(2, "Real", "enum_ct_virtual_no_real");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumCtVirtualNo.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isRealAndVirtual() { return this === EnumCtVirtualNo.realAndVirtual; }
  public isVirtual() { return this === EnumCtVirtualNo.virtual; }
  public isReal() { return this === EnumCtVirtualNo.real; }

  public static getValues(): readonly EnumCtVirtualNo[] {
    return EnumCtVirtualNo.allValues;
  }

  public static getValuesExcept0(): readonly EnumCtVirtualNo[] {
    return EnumCtVirtualNo.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumCtVirtualNo {
    const found = EnumCtVirtualNo.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumCtVirtualNo - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumCtVirtualNo): EnumCtVirtualNo {
    const found = name ? EnumCtVirtualNo.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumCtVirtualNo - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumCtVirtualNo>): boolean {
    return this.key === other?.key;
  }
}